import { render, staticRenderFns } from "./HandleNodeDetail.vue?vue&type=template&id=01a68ed0&"
import script from "./HandleNodeDetail.vue?vue&type=script&lang=js&"
export * from "./HandleNodeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports